import { render, staticRenderFns } from "./PDT.vue?vue&type=template&id=1a56a7d8&scoped=true&"
import script from "./PDT.vue?vue&type=script&lang=ts&"
export * from "./PDT.vue?vue&type=script&lang=ts&"
import style0 from "./PDT.vue?vue&type=style&index=0&id=1a56a7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56a7d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VCol,VContainer,VIcon,VRow,VSpacer,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a56a7d8')) {
      api.createRecord('1a56a7d8', component.options)
    } else {
      api.reload('1a56a7d8', component.options)
    }
    module.hot.accept("./PDT.vue?vue&type=template&id=1a56a7d8&scoped=true&", function () {
      api.rerender('1a56a7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/PDT.vue"
export default component.exports